const BRAND_VERSION = "20260726-brand-v3-hd";

export default function BrandLockup({
  className = "",
  variant = "auto",
  label = "Callsect — Turn Calls Into Action",
}) {
  const classes = ["brand-lockup", className].filter(Boolean).join(" ");
  const darkSrc = `/callsect-logo-dark.png?v=${BRAND_VERSION}`;
  const lightSrc = `/callsect-logo-light.png?v=${BRAND_VERSION}`;

  return (
    <span className={classes} role="img" aria-label={label}>
      {variant !== "light" && (
        <img
          src={darkSrc}
          alt=""
          aria-hidden="true"
          className={`brand-lockup__image${variant === "auto" ? " brand-lockup__image--dark" : ""}`}
          draggable="false"
        />
      )}
      {variant !== "dark" && (
        <img
          src={lightSrc}
          alt=""
          aria-hidden="true"
          className={`brand-lockup__image${variant === "auto" ? " brand-lockup__image--light" : ""}`}
          draggable="false"
        />
      )}
    </span>
  );
}
